import { WidgetViewModel } from './WidgetViewModel';
import { EquationOptionsWidgetView } from '../../Views';
import { EditorDOMUtils } from 'Editor/services/_Common/DOM';
import ReduxInterface from 'Editor/services/ReduxInterface/ReduxInteface';

export class EquationsOptionsWidgetModel extends WidgetViewModel<'equationOptions'> {
  constructor(
    Visualizer: Editor.Visualizer.State,
    refView: Editor.Visualizer.WidgetDataMapper['equationOptions']['view'],
    props: Editor.Visualizer.WidgetDataMapper['equationOptions']['props'],
  ) {
    super(Visualizer, refView, props);

    this.container.dataset.type = 'equationOptions';
  }

  render() {
    const parent = this.container.parentElement;
    const ref = this.refView.children[0].children[0];
    // set widget position
    const offsets = EditorDOMUtils.getOffsets(ref);
    if (offsets) {
      const zoom = ReduxInterface.getZoomValue() || 1;

      this.container.style.position = 'absolute';
      this.container.style.top = `${offsets.top}px`;

      if (this.Visualizer.getLayoutType?.() === 'PAGE') {
        if (parent && ref) {
          const refLeft = ref.getBoundingClientRect().left;
          const parentLeft = parent.getBoundingClientRect().left;
          this.container.style.left = `${(refLeft - parentLeft) / zoom}px`;
        }
      } else {
        this.container.style.left = `${offsets.left}px`;
      }

      this.container.style.height = `${offsets.height / zoom}px`;
    }

    this.renderReactComponent(<EquationOptionsWidgetView offsets={offsets} />);
  }
}
